import { useCallback } from 'react';
import { addTransportMarker } from 'shared/utils/maps/add-transport-marker.ts';
import { formatShortDateTime } from 'shared/utils/time/format-short-date-time.ts';
import type { IGetMarketsParams, IUseSetTransportsMarkersOptions } from 'components/map/map-container/hooks/types.ts';
import { useSetMarkers } from 'components/map/map-container/hooks/use-set-markers.ts';

export const useSetTransportsMarkers = ({ map, transports, truckTrailerPairs }: IUseSetTransportsMarkersOptions) => {
  const getMarkers = useCallback(
    ({ markersRef }: IGetMarketsParams) => {
      if (!map || !transports) {
        return;
      }

      transports.forEach((transport) => {
        const pairInfo = truckTrailerPairs ? truckTrailerPairs[transport.id] : undefined;

        if (transport?.lat && transport?.lng) {
          const marker = addTransportMarker({
            type: transport.type,
            map,
            position: {
              lat: transport.lat,
              lng: transport.lng,
            },
            title: transport.plateNumber,
            trailerPlateNumber: pairInfo?.trailerPlateNumber || undefined,
            warning: transport.geoOutdated,
            extraData: transport.geoUpdated ? [`Last GPS: ${formatShortDateTime(transport.geoUpdated)}`] : [],
          });

          markersRef.current.push(marker);
        }
      });
    },
    [map, transports, truckTrailerPairs],
  );

  useSetMarkers({ map, getMarkers });
};
